<template>
  <v-dialog
    v-model="trialPeriodDialog"
    width="500"
    overlay-color="rgba(39, 50, 64)"
    overlay-opacity="0.6"
    :fullscreen="$vuetify.breakpoint.xs ? true : false"
    persistent
    :transition="false"
  >
    <v-card>
      <v-card-title
        class="header"
        primary-title
      >
        <b>{{ $t('users.trial') }}</b>
      </v-card-title>
      <v-card-text>
        <v-flex mt-5>
          <b>{{ user.name }}</b><br><small>{{ user.email }}</small>
        </v-flex>
        <v-flex
          xs12
          mt-5
        >
          <v-switch
            v-model="form.vip_client"
            :label="$t('users.activateTrial')"
          />
        </v-flex>
        <v-flex>
          <v-menu
            v-if="form.vip_client"
            v-model="datePicker"
            :close-on-content-click="false"
            :nudge-right="120"
            top
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="formatedValidTillDate"
                :label="$t('globals.validTill')"
                prepend-icon="mdi-calendar"
                readonly
                v-on="on"
              />
            </template>
            <v-date-picker 
              v-model="validTillDate" 
              :locale="$i18n.locale"
              :min="$moment().add(1, 'day').format('YYYY-MM-DD')"
              @input="datePicker = false"
            />
          </v-menu>
        </v-flex>
      </v-card-text>
      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          :disabled="loading"
          @click="trialPeriodDialog = false"
        >
          <span>{{ $t('globals.cancelButton') }}</span>
        </v-btn>
        <v-btn
          color="primary"
          :disabled="loading"
          :loading="loading"
          @click="save()"
        >
          {{ $t('globals.saveButton') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>


import VIP_CLIENT_MUTATION from "@/graphql/mutations/VipClient.gql";


export default {
  name: "TrialPeriodDialog",
  props: {
    user: {
      type: Object,
      default() {
        return null;
      }
    },
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      datePicker: null,
      validTillDate: this.$moment().add(1, 'month').format('YYYY-MM-DD'),
      form: {
        user_uuid: this.user.uuid,
        vip_client: this.user.vip_client,
        vip_client_valid_till: null,
      }
    };
  },
  computed: {
    trialPeriodDialog: {
      get() {
        return this.showDialog;
      },
      set(val) {
        this.$emit('closeTrialPeriodDialog', false);
      }
    },
    formatedValidTillDate() {
      return this.$moment(this.validTillDate).format('ll');
    },
  },
  mounted() {
    if (this.user.vip_client_valid_till) {
      this.validTillDate = this.$moment(this.user.vip_client_valid_till).format('YYYY-MM-DD')
    }
  },
  methods: {
     save() {
      if (this.form.vip_client) {
        this.form.vip_client_valid_till = this.validTillDate + "23:59:59"
      } else {
        delete this.form.vip_client_valid_till
      }

      this.$apollo
        .mutate({
          mutation: VIP_CLIENT_MUTATION,
          variables: this.form
        })
        .then(data => {
          this.loading = false;
          this.$emit('closeTrialPeriodDialog', true);
        })
        .catch(error => {
          this.errorHandler(error);
          this.loading = false;
        });
    }
  },
};
</script>

<style lang="scss" >
</style>
